import Charity from "./Charity";
import { charities } from "constants/charities";
import st_ac from "./AllCharities.module.css";

const AllCharities = () => {
    const charityArray = Array.from(charities).map(([id, value]) => ({id, value}));

    return (
        <section className={st_ac.section} id="all_charities">
            <div className={st_ac.inner_container}>
                <h1 className={st_ac.big_title}>Humanitarian Relief Partners</h1>
                <p className={st_ac.intro_paragraph}>
                    Donate to one of the charities that help the Ukrainian effort directly
                </p>
                <div className={st_ac.charity_grid}>
                    {charityArray
                    .map((info, i) => <Charity key={i} id={info.id} charityInfo={info.value}/>)}
                </div>
                <div className={st_ac.disclaimer_container}>
                    <p className={st_ac.disclaimer}>
                    Angel Protocol is in process of onboarding additional organizations supporting humanitarian relief efforts to be featured here soon. 
                    We are intending to direct funds towards humanitarian/refugee efforts. 
                    <br/>
                    <br/>
                    If you'd like to join the discussion on which orgs should be featured, please jump into our <span><a href="https://forum.angelprotocol.io/t/discussion-ukraine-fundraising-humanitarian-relief-organizations/178" target="_blank">governance forum</a></span>
                    </p>
                </div>
            </div>
        </section>
    )
}

export default AllCharities;